<div class="client-body">
  <div class="sidebar-container">
    <div class="app-name">
      <p>SyncHPC</p>
      <p>Access</p>
    </div>
    <div class="entity-container">
      <div class="entity">
        <a class="entity-link">
          <i class="bi bi-display entity-icon"></i>
        </a>
        <p>Sessions</p>
      </div>
    </div>
    <div class="sidebar-footer">
      <div>
        <p>V20.15.258</p>
      </div>
    </div>
  </div>
  <div class="header-body-container">
    <div class="header">
      <div class="date-time-container">
        <p class="day-date">{{newDate | date:'fullDate'}}</p>
        <p class="header-time">{{newDate | date: 'shortTime'}}</p>
      </div>
      <div class="user-name-icon-container">
        <div class="user-name-container">
          <p>{{currentLoggedInUser}}</p>
        </div>
        <div class="user-icon-container">
          <span><i class="bi bi-person-circle"></i></span>
        </div>
      </div>
    </div>
    <div style="width: 97%; height: 2px; background: var(--s-primary-color); margin: auto "></div>
    <div class="main-body">
      <div *ngFor="let dep of clientSessions let i = index" class="deployment-container">
        <div class="deployment">
          <div style="display:flex;height:100%; flex-direction:row; align-items:center; padding:5px">
            <svg (dblclick)="getSessionFromDeployment(dep.deploymentName)" width="68px" height="68px" viewBox="0 -117.5 1259 1259" class="icon ms-2" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M393.644285 971.514095l472.373142 0 0 52.485905-472.373142 0 0-52.485905Z" fill="var(--s-primary-color)"></path><path d="M524.859047 652.399795h209.943618v345.357253h-209.943618z" fill="var(--s-primary-color)"></path><path d="M708.559713 678.642747V970.989236h-157.457714V678.642747h157.457714m52.485905-52.485904H498.616094V1023.475141h262.429524V626.156843z" fill="var(--s-primary-color)"></path><path d="M26.242952 26.242952l1207.175808 0 0 734.802666-1207.175808 0 0-734.802666Z" fill="var(--s-primary-color)"></path><path d="M1207.175807 52.485905v682.31676H52.485905V52.485905h1154.689902m0-52.485905H52.485905a52.485905 52.485905 0 0 0-52.485905 52.485905v682.31676a52.485905 52.485905 0 0 0 52.485905 52.485905h1154.689902a52.485905 52.485905 0 0 0 52.485905-52.485905V52.485905a52.485905 52.485905 0 0 0-52.485905-52.485905z" fill="var(--s-primary-color)"></path><path d="M52.485905 763.669913a26.242952 26.242952 0 0 1-26.242953-26.242952v-100.510508h1207.175808v100.248078a26.242952 26.242952 0 0 1-26.242953 26.242952z" fill="var(--s-primary-color)"></path><path d="M1207.175807 663.159405v74.267556H52.485905v-74.267556h1154.689902m52.485905-52.485904H0v126.49103a52.485905 52.485905 0 0 0 52.485905 52.485905h1154.689902a52.485905 52.485905 0 0 0 52.485905-52.485905v-126.49103z" fill="var(--s-primary-color)"></path></g></svg>
            <p style="font-size:1.3em; margin-left: 5%">{{dep.deploymentName}}</p>
          </div>
        </div>
        <div class="sessions-container" *ngIf="dep.sessions.length > 0">
          <!--<div class="w-100 h-100 m-0 p-0">-->
          <div *ngFor="let session of dep.sessions" class="single-session-container">
            <div class="session-wrapper">
              <div class="session-wrapper_session-name">
                <p title="{{session.name}}" style="margin:0; color:var(--s-primary-color); display:inline-block">
                  {{session.name}}
                </p>
              </div>
              <div class="session-wrapper_session-state">
                <p style="margin:0">{{session.aliasState}}</p>
              </div>
              <div class="session-wrapper_session-buttons">
                <button style="width: 50%; background-color: var(--s-body-color); border: none">
                  <span class="bi bi-link"
                        style="color: var(--s-primary-color); font-size:larger;"
                        title="Connect to on-going session"
                        [ngStyle]="{'opacity': session.state != 'WTSRequested' ? '1' : '0.2'}"
                        (click)="clientConnectSession(session)">
                  </span>
                </button>
                <button style="width: 50%; background-color: var(--s-body-color); border:none">
                  <span class="bi bi-box-arrow-right"
                        style="color: var(--s-primary-color); font-size:larger;"
                        title="Connect to on-going session"
                        (click)="removeSession(session)">
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
